import React from "react";
import { FlatList, StyleSheet } from "react-native";

import { FilterButton } from "./FilterButton";
import { SelectedFilterButton } from "./SelectedFilterButton";
import { Filter } from "@/app/types/config";

interface Props {
  filters: Filter[];
  getName: (filter: Filter) => string;
  onPress: (category: string) => void;
  selectedCategory: string;
}

const keyExtractor = (item: Filter): string => item.category;

const FilterButtons = ({
  filters,
  getName,
  onPress,
  selectedCategory,
}: Props) => {
  const renderItem = ({ item }: { item: Filter }) => {
    const { category } = item;
    const props = {
      onPress: () => onPress(category),
      text: getName(item),
    };

    return category === selectedCategory ? (
      <SelectedFilterButton {...props} />
    ) : (
      <FilterButton {...props} />
    );
  };

  return (
    <FlatList
      testID="filterButtons"
      contentContainerStyle={styles.container}
      data={filters}
      horizontal
      keyExtractor={keyExtractor}
      renderItem={renderItem}
      showsHorizontalScrollIndicator={false}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    gap: 16,
  },
});

export { FilterButtons };
